import './scss/bitrix-catalog-element-offer.scss';
import 'ui.swiper';

document.addEventListener('DOMContentLoaded', () => {

    // Галерея
    let productPhotoMain = document.querySelector('.product-main__photo-main img');

    function productPhotoRemoveClass(selector) {
        selector.forEach(function (el, index) {
            el.classList.remove('active');
        });
    }

    function galleryCreateListener() {
        let productPhotoThumbLi = document.querySelectorAll('.product-main__photo-thumb li');
        productPhotoThumbLi.forEach(function (el, index) {
            el.addEventListener('click', (e) => {
                productPhotoRemoveClass(productPhotoThumbLi);
                e.target.parentNode.classList.add('active');
                productPhotoMain.setAttribute('src', e.target.getAttribute('src'));
            });
        });
    }

    galleryCreateListener();

    let article = document.querySelector('.product-top__code');
    let priceNow = document.querySelectorAll('.product-right__price-bl .price-now');
    let priceOld = document.querySelectorAll('.product-right__price-bl .price-old');
    let skuSwitchBtns = document.querySelectorAll('.product-main__anons-options ul li button');
    let toBasketButton = document.querySelectorAll('.basket-btn');

    skuSwitchBtns.forEach((el) => {
        el.addEventListener('click', (e) => {
            let btnTipe = e.target.dataset.skuOptionsBtn;
            document.querySelectorAll(`[data-sku-options-btn="${btnTipe}"]`).forEach(button => {
                button.classList.remove('active');
            });
            e.target.classList.add('active');
            let acquiring = document.querySelector('[data-sku-options-btn="Эквайринг"].active').dataset.skuOptionsBtnValue;
            let color = document.querySelector('[data-sku-options-btn="Цвет"].active').dataset.skuOptionsBtnValue;
            let fiscalAccumulator = document.querySelector('[data-sku-options-btn="Фискальный накопитель"].active').dataset.skuOptionsBtnValue;
            let typeOfLicense = document.querySelector('[data-sku-options-btn="Тип лицензии"].active').dataset.skuOptionsBtnValue;
            let skuModification = document.querySelector('[data-sku-options-btn="Модификация"].active').dataset.skuOptionsBtnValue;
            let selectedSku = Window.sortedOffers[acquiring][color][fiscalAccumulator][skuModification][typeOfLicense];
            let skuStatus = document.querySelectorAll('.product-right__price-status');
            let oneStepToBuyBtn = document.querySelectorAll('.one-step-to-buy');
            let analogsLink = document.querySelectorAll('.analogs-link');
            let outOfStockLink = document.querySelectorAll('.out-of-stock-link');
            article.innerHTML = `Код товара ${selectedSku['ARTICLE']}`;

            priceNow.forEach((el) => {
                el.innerHTML = selectedSku['DISPLAY_PRICE'];
            });

            priceOld.forEach((el) => {
                el.innerHTML = selectedSku['DISPLAY_OLD_PRICE'] ? selectedSku['DISPLAY_OLD_PRICE'] : '';
            });

            toBasketButton.forEach((el) => {
                el.dataset.productId = selectedSku['ID'];
            });

            let basketSkuStatus = selectedSku['IN_BASKET'];
            if (Window.hasOwnProperty('skuBasketStatus') && Window.skuBasketStatus.hasOwnProperty(selectedSku['ID'])) {
                basketSkuStatus = Window.skuBasketStatus[selectedSku['ID']] == 'added';
            }

            skuStatus.forEach((el) => {
                if(selectedSku.QUANTITY.CLASS) {
                    el.innerHTML = selectedSku.QUANTITY.TEXT;
                    el.removeAttribute('class');
                    el.classList.add('product-right__price-status', selectedSku.QUANTITY.CLASS);
                }
                else {
                    el.innerHTML = 'Товар в наличии';
                    el.removeAttribute('class');
                    el.classList.add('product-right__price-status', 'status-stock');
                }

            switch (selectedSku.QUANTITY.CLASS) {
                case 'status-stock':
                    toBasketButton.forEach((el) => {
                        el.classList.remove('disabled');
                        el.dataset.disabled = false;
                    });
                    oneStepToBuyBtn.forEach((el) => {
                        el.classList.remove('d-none');
                    });
                    analogsLink.forEach((el) => {
                        el.classList.add('d-none');
                    });
                    outOfStockLink.forEach((el) => {
                        el.classList.add('d-none');
                    });
                    break;
                case 'status-out-of-stock':
                    toBasketButton.forEach((el) => {
                        el.classList.add('disabled');
                        el.dataset.disabled = true;
                    });
                    oneStepToBuyBtn.forEach((el) => {
                        el.classList.add('d-none');
                    });
                    analogsLink.forEach((el) => {
                        el.classList.add('d-none');
                    });
                    outOfStockLink.forEach((el) => {
                        el.classList.remove('d-none');
                    });
                    break;
                case 'status-out-of-fabric':
                    toBasketButton.forEach((el) => {
                        el.classList.add('disabled');
                        el.dataset.disabled = true;
                    });
                    oneStepToBuyBtn.forEach((el) => {
                        el.classList.add('d-none');
                    });
                    analogsLink.forEach((el) => {
                        el.classList.remove('d-none');
                    });
                    outOfStockLink.forEach((el) => {
                        el.classList.add('d-none');
                    });
                    break;
                default:
                    toBasketButton.forEach((el) => {
                        el.classList.remove('disabled');
                        el.dataset.disabled = false;
                    });
                    oneStepToBuyBtn.forEach((el) => {
                        el.classList.remove('d-none');
                    });
                    analogsLink.forEach((el) => {
                        el.classList.add('d-none');
                    });
                    outOfStockLink.forEach((el) => {
                        el.classList.add('d-none');
                    });
            }
            });


            console.log(selectedSku);

            // if (selectedSku['OUT_OF_STOCK']) {
            //     toBasketButton.classList.add('disabled');
            //     toBasketButton.dataset.disabled = true;
            //     skuStatus.innerText = 'Нет в наличии';
            //     skuStatus.classList.add('status-no');
            //     skuStatus.classList.remove('status-stock');
            //     if(document.querySelector('.similar-products')) {
            //         oneStepToBuyBtn.classList.add('d-none');
            //         analogsLink.classList.remove('d-none');
            //     }
            // }
            // else {
            //     toBasketButton.classList.remove('disabled');
            //     toBasketButton.dataset.disabled = false;
            //     skuStatus.innerText = 'Товар в наличии';
            //     skuStatus.classList.remove('status-no');
            //     skuStatus.classList.add('status-stock');
            //     if(document.querySelector('.similar-products')) {
            //         oneStepToBuyBtn.classList.remove('d-none');
            //         analogsLink.classList.add('d-none');
            //     }
            // }

            if (selectedSku['MORE_PHOTO']) {
                let productImgLi = document.querySelectorAll('.product-main__photo-thumb li');
                let productImgUl = document.querySelector('.product-main__photo-thumb');
                let productImgBig = document.querySelector('.product-main__photo-main img');

                productImgLi.forEach((productImg) => {
                    productImg.classList.remove('active');
                });

                productImgLi.forEach((el) => {
                    el.remove();
                })

                selectedSku['MORE_PHOTO'].forEach((el) => {
                    let li = document.createElement('li');
                    li.innerHTML = '<img src="' + el + '" alt="">';
                    productImgUl.appendChild(li);
                })
                document.querySelectorAll('.product-main__photo-thumb li')[0].classList.add('active');
                productImgBig.src = selectedSku['MORE_PHOTO'][0];
                galleryCreateListener();
            }
            checkInBasket();
        });
    });

    // Кнопка выбора региона в доставке
    let popupRegions = document.querySelector('.popup-regions');
    let productСityBtn = document.querySelector('.product-right__bl-top .product-city-btn');
    productСityBtn.addEventListener('click', () => {
        popupRegions.style.display = 'block';
    });

    // dataLayer
    //window.taxDataLayer.addToCart()



});

// Сопутствующие товары
var swiper = new Swiper(".related-products-swiper", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 2000,
    },
    spaceBetween: 0,
    pagination: {
        el: ".category-goods .swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        992: {
            slidesPerView: 3,
        },
    },
});

// Похожие товары
var swiper = new Swiper(".similar-products-swiper", {
    slidesPerView: 1,
    pagination: {
        el: ".similar-products-swiper .swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        992: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
    },
});

